import { md5 } from 'app/utils'
import { phoneDigits } from 'lib/phone'

/** Mirror of the API's transformPhone: bare last-10-digits US number. */
export function normalizePhone(phone: string | null | undefined): string | undefined {
  if (!phone) return undefined
  const digits = phoneDigits(phone).slice(-10)
  return digits.length === 10 ? digits : undefined
}

/**
 * Sorted, normalized phone-pair key shared by `predictSmsThreadId` and the
 * inbox conversation grouping. Undefined when either phone is missing or
 * unusable so callers can fall back to a different identity instead of
 * silently merging unrelated rows.
 */
export function phonePairKey(a: string | null | undefined, b: string | null | undefined): string | undefined {
  const normalizedA = normalizePhone(a)
  const normalizedB = normalizePhone(b)
  if (!normalizedA || !normalizedB) return undefined
  return [normalizedA, normalizedB].sort().join(`,`)
}

/**
 * Predict the server's SMS thread id (md5 of the sorted, normalized phone
 * pair — see Message.beforeSave in trackable-api) for a brand-new
 * conversation. Returns undefined when either number is missing or unusable:
 * fabricating an id from a half-loaded location minted phantom threads that
 * render blank (`md5("<cell>,")` — the sort/join silently swallows undefined).
 */
export function predictSmsThreadId(
  trackingNumber: string | null | undefined,
  cellPhone: string | null | undefined,
): string | undefined {
  const pair = phonePairKey(trackingNumber, cellPhone)
  return pair ? md5(pair) : undefined
}
